import { render, staticRenderFns } from "./DeleteLanguageManagerConfirmationDialog.vue?vue&type=template&id=37dc7c04"
import script from "./DeleteLanguageManagerConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteLanguageManagerConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports